import { createApp } from 'vue';
import { addClass, removeClass } from './shared';
import Loading from './index.vue';
const relativeCls = 'hay-loading-parent--relative';
function append(el) {
  const style = getComputedStyle(el);
  if (['absolute', 'fixed', 'relative'].indexOf(style.position) === -1) {
    addClass(el, relativeCls);
  }
  el.appendChild(el.instance.$el);
}
function remove(el) {
  removeClass(el, relativeCls);
  el.removeChild(el.instance.$el);
}
const loadingDirective = {
  name: 'loading',
  mounted(el, binding) {
    const app = createApp(Loading);
    const instance = app.mount(document.createElement('div'));
    el.instance = instance;
    const title = binding.arg;
    if (typeof title !== 'undefined') {
      ;
      instance.setTitle(title);
    }
    if (typeof binding.value === 'object' && binding.value !== null && binding.value.text) {
      ;
      instance.setTitle(binding.value.text);
    }
    if (binding.value) {
      if (typeof binding.value === 'boolean') append(el);
      if (typeof binding.value === 'object' && binding.value !== null) {
        if (binding.value.value) append(el);
      }
    }
  },
  updated(el, binding) {
    const title = binding.arg;
    if (typeof title !== 'undefined') {
      el.instance.setTitle(title);
    }
    if (binding.value !== binding.oldValue) {
      // bool的情况
      if (typeof binding.value === 'boolean') {
        // eslint-disable-next-line no-unused-expressions
        binding.value ? append(el) : remove(el);
      }
      // object的情况
      if (typeof binding.value === 'object' && binding.value !== null) {
        // eslint-disable-next-line no-unused-expressions
        binding.value.value ? append(el) : remove(el);
      }
    }
  }
};
export default loadingDirective;